//* 组件库
import type { UiTableOption2 } from "various-ui";

export const useOptions = () => {
    //* 插件
    const i18n = useI18n();

    return {
        table: <UiTableOption2[]>[
            { key: "name", name: i18n.t("Title"), align: "singularity" },
            { key: "id", name: "PMID", align: "center" },
            { key: "journal", name: i18n.t("Journal"), align: "center" },
            { key: "year", name: i18n.t("Year"), align: "center", sort: true },
            { key: "jif", name: "IF", align: "center", sort: true },
        ],
    };
};
